<template>
  <div>
    <Main
      ref="main"
      :loading="loading"
      :disabled="disabled"
      :disabledPrint="disabledPrint"
      @reload="getData"
    >
      <div slot="header">
        <div class="d-flex mt-2">
          <div class="side-frame"></div>
          <div>
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_header_title') || '产品明细列表' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled"></el-divider>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="chooseAmzSku()"
              v-if="!disabled"
            >
              {{ $l('btn_chooseAmzSku') || '选择产品' }}
            </b-button>
          </div>
        </div>
      </div>
    </Main>

    <ChooseAmzFtySku
      :visible.sync="chooseAmzSkuVisible"
      :scmCode="scmCode"
      @confirm="skuConfirm"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import ChooseAmzFtySku from '@/views/ecom/components/choose-amz-fty-sku'
export default {
  components: { Main, ChooseAmzFtySku },
  props: {
    disabled: { type: Boolean, default: false },
    amzFtyNoticeInCode: { type: String, default: '' },
    amzFtyNoticeOutCode: { type: String, default: '' },
    scmCode: { type: String, default: '' },
    disabledPrint: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      chooseAmzSkuVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (this.amzFtyNoticeInCode) {
        await this.getTable(this.$api.ecomAmzFtyNoticeInDetailListApi, {
          amzFtyNoticeInCode: this.amzFtyNoticeInCode,
        })
      }
      if (this.amzFtyNoticeOutCode) {
        await this.getTable(this.$api.ecomAmzFtyNoticeOutDetailListApi, {
          amzFtyNoticeOutCode: this.amzFtyNoticeOutCode,
        })
      }
    },

    async getTable(api, param) {
      this.loading = true
      const res = await api({ ...param }).catch(() => null)
      this.loading = false
      if (!res) return
      const { data } = res.body
      this.$refs.main.setData(data || [])
    },

    chooseAmzSku() {
      if (this.scmCode) return (this.chooseAmzSkuVisible = true)
      this.$message.warning(
        this.$l('tips_chooseAmzSku_Scm') || '请先选择入库通知单供应商！'
      )
    },
    async skuConfirm(data) {
      if (!data || !data.length) return
      const tableData = await this.getTableData()
      if (tableData && tableData.length) {
        data = data.filter(
          (i) => !tableData.map((j) => j.amzSkuCode).includes(i.amzSkuCode)
        )
      }
      if (!data || !data.length) return
      data = data.map((item) => ({
        ...item,
        ncNo: item.ftyNcNo || item.ncNo,
      }))
      this.$refs.main.insertAt(data)
    },
    validate() {
      return this.$refs.main.validate()
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  height: 20px;
  margin-top: 3px;
}
</style>
